import { caption as captionFactory } from '../../next-schema/generated/nodeTypes';

/**
 * @name caption_node
 */

export var caption = captionFactory({
  parseDOM: [{
    tag: 'figcaption[data-caption]'
  }],
  toDOM: function toDOM() {
    var attrs = {
      'data-caption': 'true'
    };
    return ['figcaption', attrs, 0];
  }
});